import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-style-two',
  templateUrl: './pricing-style-two.component.html',
  styleUrls: ['./pricing-style-two.component.scss']
})
export class PricingStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
